export default __webpack_public_path__ + "static/media/apple-pay.39a847d0.svg";